import {
  // Print,
  CallOutlined,
} from "@mui/icons-material";
import React from "react";

export default function CallLogHeader() {
  return (
    <div className="border-1 flex flex-row-reverse justify-between border-b border-black px-3 pt-4">
      <div className="mx-auto my-2 w-[50%] text-right"></div>

      <div className="w-[50%] self-end rounded-t-md">
        <h2 className="flex w-full flex-row items-center py-1 text-center text-lg">
          <div className="mb-1 mr-1 block">
            <CallOutlined />
          </div>
          <span className="block">Call Log</span>
        </h2>
      </div>
    </div>
  );
}
